import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSquare = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 1024,
	zoomAndPan: "magnify",
	viewBox: "0 0 768 767.999994",
	height: 1024,
	preserveAspectRatio: "xMidYMid meet",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: -76.8,
			width: 921.6,
			fill: "#ffffff",
			y: -76.799999,
			height: 921.599993,
			fillOpacity: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: -76.8,
			width: 921.6,
			fill: "#f2e5dd",
			y: -76.799999,
			height: 921.599993,
			fillOpacity: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#033744",
			d: "M 355.976562 186.964844 C 356.160156 189.925781 357.390625 192.207031 359.796875 193.871094 L 359.734375 193.933594 C 360.246094 194.042969 360.757812 194.167969 361.269531 194.296875 C 362.820312 194.679688 364.40625 195.074219 366.019531 194.980469 C 369.714844 194.796875 373.414062 192.699219 376.308594 190.664062 C 382.535156 186.285156 387.339844 179.75 391.222656 173.398438 C 393.125 170.328125 393.582031 169.792969 393.632812 169.226562 C 393.679688 168.617188 393.273438 167.972656 393.6875 164.148438 C 394.425781 156.875 392.207031 150.460938 389.3125 143.925781 C 387.523438 139.730469 382.164062 140.164062 378.714844 141.519531 C 373.105469 143.679688 367.4375 149.597656 364.046875 154.222656 C 359.425781 160.511719 360.597656 155.394531 358.6875 162.976562 C 357.761719 166.738281 356.960938 170.5625 357.390625 174.324219 C 356.652344 176.667969 356.160156 179.132812 355.976562 181.539062 Z M 576.085938 301.59375 C 552.855469 247.457031 531.226562 218.042969 531.226562 218.042969 L 531.164062 218.042969 C 472.378906 269.097656 399.292969 342.105469 356.40625 392.914062 C 331.695312 350.492188 245.058594 241.289062 240.433594 230.4375 C 240.3125 230.066406 203.339844 286.179688 207.960938 293.886719 C 219.238281 312.632812 308.957031 444.773438 313.457031 448.71875 C 248.199219 521.726562 187.871094 710.105469 172.222656 837.128906 C 172.222656 837.375 270.566406 838.175781 270.628906 837.4375 C 315.316406 480.820312 557.425781 314.4375 575.070312 302.308594 C 575.746094 301.847656 576.089844 301.605469 576.085938 301.59375 Z M 576.085938 301.59375 ",
			fillOpacity: 1,
			fillRule: "evenodd"
		})
	]
});
export default SvgIconSquare;
